import { ENV, REVISION } from '@sorare/core/src/config';
import { startSentry } from '@sorare/core/src/contexts/sentry/sentry';
import { SO5_SENTRY_DSN } from '@sorare/core/src/variables';

const { createBrowserRouter } = startSentry({
  dsn: SO5_SENTRY_DSN,
  env: ENV,
  release: REVISION.toString(),
  app: 'sorare',
});

export { createBrowserRouter };
